import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { AnalyticsMock } from '../mockups/AnalyticsMock';
import { AppWindow } from '../mockups/AppWindow';
import { ParallaxFrame } from '../ui/ParallaxFrame';
import { Reveal } from '../ui/Reveal';
export function Insights() {
  const {
    t
  } = useLanguage();
  return <section id="informacion" className="overflow-hidden bg-white py-28 md:py-40" data-id="element-172" data-mp="10mkoktnucux6">
      <div className="mx-auto max-w-6xl px-5 md:px-6" data-id="element-173" data-mp="1xail01zl566l">
        <Reveal data-id="element-174" data-mp="1t9yngxb3o0jx">
          <h2 className="max-w-4xl text-5xl font-semibold leading-[1.02] tracking-[-0.035em] text-graphite md:text-7xl" data-id="element-175" data-mp="1t9f3zc5sx43s">
            {t.insights.title}
          </h2>
        </Reveal>
        <Reveal delay={0.08} data-id="element-176" data-mp="1jbr6wfkq3kig">
          <p className="mt-6 max-w-xl text-lg leading-snug text-subtle md:text-2xl" data-id="element-177" data-mp="1jck5uudfx5q1">
            {t.insights.text}
          </p>
        </Reveal>
        <ParallaxFrame className="mt-14 md:mt-20" data-id="element-178" data-mp="ctlxelwceu8j">
          <AppWindow data-id="element-179" data-mp="7wcape0c8woe">
            <AnalyticsMock data-id="element-180" data-mp="7vu3xng1v028" />
          </AppWindow>
        </ParallaxFrame>
      </div>
    </section>;
}